<template>
  <transition name="modal">
    <div class="sef-modal-mask" v-if="show">
      <div id="cardnotif"
        class="card notif"
        :style="{ width: jsondata && jsondata.length > 0 ? '80%' : '35%' }"
      >
        <div class="card-header">
          <div class="card-title">
            <p style="margin-left: 4px">{{ title }}</p>
          </div>
          <div class="btn-actions-pane-right">
            <div class="btn-group-sm btn-group" role="group">
              <a href="#" class="active btn btn-focus" @click="doAction(false)">
                <i class="scf-close"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-body-container">
            <!-- contenu du popup -->
            <div class="modal-body">
              <!-- First row: Load Configuration -->
              <div class="row mb-3 align-items-center">
                <div class="col">
                  <label class="form-label mb-0"
                    >{{ $t("pages.Client.LoadConfiguration") }}:</label
                  >
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="loadConfiguration"
                  >
                    {{ $t("pages.Client.SelectFile") }}
                  </button>
                  <input
                    type="file"
                    ref="fileInput"
                    style="display: none"
                    accept=".xls,.xlsx"
                    @change="handleFileUpload"
                  />
                </div>
              </div>

              <!-- Second row: Export Configuration -->
              <div
                class="row mb-3 align-items-center"
                v-if="jsondata && jsondata.length > 0"
              >
                <div class="col">
                  <label class="form-label mb-0"
                    >{{ $t("pages.Client.ExportConfiguration") }}:</label
                  >
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="exportHierarchyToExcel(jsondata)"
                  >
                    {{ $t("pages.Client.ExportFile") }}
                  </button>
                </div>
              </div>

              <!-- new bloc -->
              <div class="row">
                <div class="col">
                  <div id="demo">
  
<!-- First row -->
<div
  style="
    display: flex;
    margin: 0px;
    margin-left: 20px;
    margin-right: 12px;
    background: #343a40;
  "
  v-if="jsondata && jsondata.length != 0"
>
  <!-- Bloc 1 -->
  <div
    style="
      width: 49.5%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0.5rem;
      box-shadow: none;
      border: none;
      outline: none;
      backface-visibility: hidden;
      transform: translateZ(0);
      border-right: 1px solid transparent;
    "
  >
      {{ this.$t("pages.Client.LevelsHierarchy") }}
  </div>

  <!-- Bloc 2 -->
  <div
    style="
      width: 20%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0;
      box-shadow: none;
      border: none;
      outline: none;
      backface-visibility: hidden;
      transform: translateZ(0);
      border-right: 1px solid transparent;
    "
  >
    <div
      style="
        display: flex;
        padding: 0.5rem;
        margin-left: 31px;
        flex-wrap: wrap;
        box-shadow: none;
        border: none;
        outline: none;
      "
    >
      {{ this.$t("pages.Client.PrfDetails") }}
    </div>
  </div>

  <!-- Bloc 3 (pas de border-right ici !) -->
  <div
    style="
      width: 30.5%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0.5rem;
      box-shadow: none;
      border: none;
      outline: none;
      backface-visibility: hidden;
      transform: translateZ(0);
    "
  >
      {{ this.$t("pages.Client.HierarchyCode") }}
  </div>
</div>


<!-- Second row -->
<div
  style="
    display: flex;
    margin: 0px;
    margin-left: 20px;
    margin-right: 12px;
     background: #343a40;
  "
  v-if="jsondata && jsondata.length != 0"
>
  <div
    style="
      width: 49.5%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0.5rem;
      border: none;
      outline: none;
      box-shadow: none;
      backface-visibility: hidden;
    "
  >
  </div>

  <div
    style="
      width: 20%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
      box-shadow: none;
      backface-visibility: hidden;
    "
  >
    <div
      style="
        display: flex;
        padding: 0.5rem;
        flex-wrap: wrap;
        border: none;
        outline: none;
        box-shadow: none;
      "
    >
      <span style="margin-right: 12px; margin-left: 15px">{{ this.$t("pages.Client.OneDay") }}</span>
      <span style="margin-right: 12px">{{ this.$t("pages.Client.FiveDays") }}</span>
      <span style="margin-right: 12px">{{ this.$t("pages.Client.SevenDays") }}</span>
      <span style="margin-right: 12px">{{ this.$t("pages.Client.TenDays") }}</span>
      <span style="margin-right: 11px">{{ this.$t("pages.Client.ThirtyDays") }}</span>
    </div>
  </div>

  <div
    style="
      width: 30.5%;
      background: #343a40;
      color: white;
      margin: 0;
      padding: 0.5rem;
      border: none;
      outline: none;
      box-shadow: none;
      backface-visibility: hidden;
    "
  >
  </div>
</div>


                    <!-- end col -->
                    <p
                      class="alert alert-warning alert-dismissible d-flex align-items-center fade show"
                      v-if="!jsondata || jsondata.length === 0"
                    >
                      <strong class="mx-2">
                        {{ $t("pages.Client.Warning") }}</strong
                      >
                      {{
                        $t("pages.Client.TereIsNoConfiguration") ||
                        "Veuillez charger une configuration."
                      }}
              
 


<button @click="downloadEmptyModel" type="button" class="Btn" style="margin-left:1%">
   <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
   <span class="icon2"></span>
   <span class="tooltip"> {{
                        $t("pages.Client.Download")  
                      }}</span>
</button>
 
                    </p>
                    <ul v-else>
                      <li
                        v-for="(item, index) in jsondata"
                        :key="index"
                        style="list-style: none"
                      >
                        <json-edit
                          :model="item.hierarchy"
                            :levelsNumber="item.levelsNumber"
                          @modified="markChanged"
                        ></json-edit>
                      </li>
                    </ul>
                  </div>

                  <!--- begin -->
                  <!-- end info alert -->
                </div>
              </div>

              <!-- Warning Alert -->

              <!-- <div class="alert alert-warning alert-dismissible d-flex align-items-center fade show">
<strong class="mx-2">Warning!</strong> There was a problem with your network connection.
</div> -->
              <!-- end new bloc -->
            </div>

            <!-- end content of popup -->
          </div>
        </div>
        <div class="modal-footer" v-if="['create', 'edit'].includes(fromPage)">
          <button
            type="button"
            class="btn btn-primary"
            @click="doAction(false)"
          >
            {{ $t("common.cancel") }}
          </button>
          <button
            type="button"
            :disabled="!hasChanged"
            class="btn btn-primary"
            @click="doAction(true)"
          >
            {{ $t("pages.Client.validate") }}
          </button>
        </div>
        <div
          v-else
          class="modal-footer"
          style="justify-content: center !important"
        >
          <button type="button" class="btn btn-primary" @click="close()">
            {{ $t("pages.Client.ok") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent, computed } from "vue";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import JsonEdit from "../components/JsonEdit.vue";
import ClientService from "../services/ClientService";

export default defineComponent({
  name: "formModalOrganizations",
  inject: ["accessToken"],
  components: { JsonEdit },
  data() {
    return {
      modalShow: false,
      formData: {},
      error: true,
      noData: true,
      updated: true,
      hasChanged: false,
      parametersChanged: false,
      currentScope: this.$jwt.scope,
      culture: computed(() => this.$i18n.locale),
      clientService: new ClientService(this.$jwt.token, this.$jwt.scope),
      popupOpen: false, // État pour gérer l'ouverture/fermeture de la popup
      originalJsonData: null, // Sauvegarde des données initiales pour l'annulation
      isDataFromDatabase: false, // Indique si les données proviennent de la base de données
      initialJsonData: [
        {
          project: "SAINTDIE",
          status: "Migrating",
          levelsNumber: 3,
          levels: ["City", "Postcode", "new"],
          timezone: "Europe/Paris",
          culture: "fr-FR",
          gdpr: true,
          hierarchy: {
            scope: "ALL.SAINTDIE",
            name: "SAINTDIE",
            parameters: {
              performanceRadioFrameThreshold_1: null,
              performanceRadioFrameThreshold_5: null,
              performanceRadioFrameThreshold_7: null,
              performanceRadioFrameThreshold_10: null,
              performanceRadioFrameThreshold_30: null,
            },
            children: [
              {
                scope: "ALL.SAINTDIE.SAINT_DIE_DES_VOSGES",
                name: "SAINT_DIE_DES_VOSGES",
                parameters: {
                  performanceRadioFrameThreshold_1: null,
                  performanceRadioFrameThreshold_5: null,
                  performanceRadioFrameThreshold_7: null,
                  performanceRadioFrameThreshold_10: null,
                  performanceRadioFrameThreshold_30: null,
                },
                children: [
                  {
                    scope: "ALL.SAINTDIE.SAINT_DIE_DES_VOSGES.88100",
                    name: "88100",
                    parameters: {
                      performanceRadioFrameThreshold_1: null,
                      performanceRadioFrameThreshold_5: null,
                      performanceRadioFrameThreshold_7: null,
                      performanceRadioFrameThreshold_10: null,
                      performanceRadioFrameThreshold_30: null,
                    },
                    children: [
                      {
                        scope: "ALL.SAINTDIE.SAINT_DIE_DES_VOSGES.88100.88413",
                        name: "88413",
                        parameters: {
                          performanceRadioFrameThreshold_1: null,
                          performanceRadioFrameThreshold_5: null,
                          performanceRadioFrameThreshold_7: null,
                          performanceRadioFrameThreshold_10: null,
                          performanceRadioFrameThreshold_30: null,
                        },
                        children: [],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      ],
      jsondata: [],

      jsonData2: [
        {
          project: "ALM",
          status: "DoubleRun",
          levelsNumber: 1,
          levels: ["Ville"], // For multiple levels, e.g. ["Ville", "PostalCode"]
          timezone: "Europe/Paris",
          culture: "fr-FR",
          gdpr: true,
          hierarchy: {
            scope: "ALL.ALM",
            name: "ALM",
            parameters: {
              performanceRadioFrameThreshold_1: null,
              performanceRadioFrameThreshold_5: null,
              performanceRadioFrameThreshold_7: null,
              performanceRadioFrameThreshold_10: null,
              performanceRadioFrameThreshold_30: null,
            },
            children: [
              {
                scope: "ALL.ALM.ANGERS",
                name: "Angers",
                parameters: {},
                children: [
                  {
                    scope: "ALL.ALM.ANGERS.49007",
                    name: "49007",
                    parameters: {
                      performanceRadioFrameThreshold_1: null,
                      performanceRadioFrameThreshold_5: null,
                      performanceRadioFrameThreshold_7: null,
                      performanceRadioFrameThreshold_10: null,
                      performanceRadioFrameThreshold_30: null,
                    },
                    children: [],
                  },
                ],
              },
              {
                scope: "ALL.ALM.TestIBA",
                name: "TestIBA",
                parameters: {},
                children: [
                  {
                    scope: "ALL.ALM.TestIBA.49004",
                    name: "49004",
                    parameters: {
                      performanceRadioFrameThreshold_1: null,
                      performanceRadioFrameThreshold_5: null,
                      performanceRadioFrameThreshold_7: null,
                      performanceRadioFrameThreshold_10: null,
                      performanceRadioFrameThreshold_30: null,
                    },
                    children: [],
                  },
                  {
                    scope: "ALL.ALM.TestIBA.49001",
                    name: "49001",
                    parameters: {
                      performanceRadioFrameThreshold_1: null,
                      performanceRadioFrameThreshold_5: null,
                      performanceRadioFrameThreshold_7: null,
                      performanceRadioFrameThreshold_10: null,
                      performanceRadioFrameThreshold_30: null,
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
        },
      ],
      loadedfile: null,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    client: {
      type: String,
      required: true,
    },
    nbZones: {
      required: false,
    },
    levels: {
      required: false,
    },
    hierarchyItem: {
      required: false,
    },
    fromPage: {
      required: false,
      default: "create",
    }
  },

  mounted() {
    this.fillInitialFormData();
  },
  created() {
    this.resetModel();
  },
  methods: {
    downloadEmptyModel() {
  const levels = this.levels || [];
  const headers = [...levels, "groupingCode"];

  const aoa = [headers]; // Only the header row, no data

  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Hierarchies");

  XLSX.writeFile(workbook, "Template organization file.xlsx");
},
    fillInitialFormData() {
      // if (this.initialLevels) {
      //   console.log("🚀 ~ fillInitialFormData  called~ initialLevels:", this.initialLevels);
      //   for (let index = 1; index <= this.nbZones; index++) {
      //     result[index] = this.initialLevels[index - 1];
      //   }
      //   this.formData = result;
      // }

      // var ss = this.clientService.getHierarchyByClient(this.client);
      console.log(
        "🚀 ~ fillInitialFormData ~ hierarchyItem:",
        this.hierarchyItem
      );
      // console.log("🚀 ~ fillInitialFormData ~ ss:", ss);

      this.formData = "hirarchical configu content...";
    },
    doAction(isTrue) {
      if (isTrue === true) {
        // Clic sur Valider - envoyer les donnu00e9es modifiu00e9es au composant parent
        console.log(
          "🚀 Envoi des donnu00e9es du composant FormModalOrg au parent (clientForm)",
          this.jsondata
        );
        
        this.$emit("update:show", this.jsondata);
      } else {
        // Clic sur Annuler
        console.log("🔙 Annulation des modifications");
        
        if (this.isDataFromDatabase) {
          // Si les donnu00e9es proviennent de la base de donnu00e9es, restaurer les donnu00e9es originales
          console.log("💾 Restauration des données originales de la base de données");
          this.jsondata = JSON.parse(JSON.stringify(this.originalJsonData));
        } else {
          // Si aucune donnu00e9e n'a u00e9tu00e9 ru00e9cupu00e9ru00e9e de la base de donnu00e9es, ru00e9initialiser le modu00e8le
          console.log("🗑️ Ru00e9initialisation du modu00e8le");
          this.resetModel();
        }
        
        // Ru00e9initialiser les indicateurs de modification
        this.hasChanged = false;
        this.parametersChanged = false;
        
        // Fermer le popup en envoyant les donnu00e9es ru00e9initialisu00e9es au composant parent
        this.$emit("update:show", this.jsondata);
      }
    },
    close() {
      // Fermeture du popup - traiter comme une annulation
      console.log("🔒 Fermeture du popup - annulation des modifications");
      
      if (this.isDataFromDatabase) {
        // Si les donnu00e9es proviennent de la base de donnu00e9es, restaurer les donnu00e9es originales
        console.log("💾 Restauration des données originales de la base de données");
        this.jsondata = JSON.parse(JSON.stringify(this.originalJsonData));
      } else {
        // Si aucune donnu00e9e n'a u00e9tu00e9 ru00e9cupu00e9ru00e9e de la base de donnu00e9es, ru00e9initialiser le modu00e8le
        console.log("🗑️ Ru00e9initialisation du modèle");
        this.resetModel();
      }
      
      // Ru00e9initialiser les indicateurs de modification
      this.hasChanged = false;
      this.parametersChanged = false;
      
      // Fermer le popup sans envoyer de donnu00e9es au composant parent
      // this.$emit("update:show", this.jsondata);
    },
    exportHierarchyToExcel(json) {
  if (!json || !json.length) {
    console.warn("initialJsonData est vide ou non défini.");
    return;
  }

  const data = json[0];
  if (!data.hierarchy) {
    console.warn("Aucune propriété 'hierarchy' trouvée dans data[0].");
    return;
  }

  const levels = data.levels || [];
  if (!levels.length) {
    console.warn("data.levels est vide ou non défini.");
    return;
  }

  const finalHeaders = [...levels, "groupingCode"];
  const allRows = [];

  const traverse = (node) => {
    const dotCount = (node.scope.match(/\./g) || []).length;

    // On ignore la racine (dotCount <= 1)
    if (dotCount > 1) {
      const currentRow = {};
      levels.forEach((h) => (currentRow[h] = ""));
      currentRow["groupingCode"] = "";

      const colIndex = dotCount - 2;
      const safeIndex = Math.min(colIndex, levels.length - 1);

      if (safeIndex >= 0 && safeIndex < levels.length) {
        currentRow[levels[safeIndex]] = node.name || "";
      }

      // ✅ Si ce nœud est au dernier niveau...
      if (
        safeIndex === levels.length - 1 &&
        node.children &&
        node.children.length
      ) {
        // ...et a des enfants sans enfants => on place leur nom dans groupingCode
        const leafChildren = node.children.filter(
          (child) => !child.children || child.children.length === 0
        );

        // Concaténer les noms dans groupingCode (séparés par virgule)
        if (leafChildren.length) {
          currentRow["groupingCode"] = leafChildren
            .map((child) => child.name || "")
            .join(", ");
        }
      }

      allRows.push(currentRow);
    }

    // Continuer à parcourir la hiérarchie sauf si on a déjà géré tous les enfants
    const isLastLevel =
      (node.scope.match(/\./g) || []).length - 2 === levels.length - 1;

    const childrenHandled =
      isLastLevel &&
      node.children &&
      node.children.every((child) => !child.children || child.children.length === 0);

    if (!childrenHandled && node.children && node.children.length) {
      node.children.forEach(traverse);
    }
  };

  traverse(data.hierarchy);

  const aoa = [finalHeaders];
  allRows.forEach((row) => {
    aoa.push(finalHeaders.map((h) => row[h] || ""));
  });

  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Hierarchy");

  const now = new Date();
  const fileName = `Organisations_${this.client}_${now.toISOString().replace(/[:T]/g, "-").slice(0, 19)}.xlsx`;

  XLSX.writeFile(workbook, fileName);
}
,


    // saveModel() {
    //   console.log("New Model:", this.jsondata);
    //   const swalWithBootstrapButtons = Swal.mixin({
    //     customClass: {
    //       confirmButton: "btn btn-success",
    //       cancelButton: "btn btn-danger",
    //     },
    //     buttonsStyling: false,
    //   });
    //   swalWithBootstrapButtons
    //     .fire({
    //       title: "Are you sure?",
    //       text: "You won't be able to revert this!",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonText: "Yes, delete it!",
    //       cancelButtonText: "No, cancel!",
    //       reverseButtons: true,
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         swalWithBootstrapButtons.fire({
    //           title: "Saved!",
    //           text: "Your config has been updated.",
    //           icon: "success",
    //         });
    //         this.popupOpen = false;
    //         this.parametersChanged = false;
    //         this.hasChanged = false;
    //       } else if (
    //         /* Read more about handling dismissals below */
    //         result.dismiss === Swal.DismissReason.cancel
    //       ) {
    //         //TODO fermer le popup
    //         // this.popupOpen = false;
    //       }
    //     });

    //   // Swal.fire({
    //   //   icon: "success",
    //   //   title: "Success",
    //   //   text: "Model saved successfully!",
    //   //   confirmButtonText: "OK",
    //   // });
    // },
    cancelChanges() {
      this.resetModel();
      this.popupOpen = false;
      this.hasChanged = false;
      this.parametersChanged = false;
      console.log("Model has been reinitialized.");
    },
    resetModel222() {
      this.jsondata = JSON.parse(JSON.stringify(this.initialJsonData)); //todo think about this .... already thinked !
      this.hasChanged = false;
      this.parametersChanged = false;
    },
    resetModel() {
      if (Array.isArray(this.hierarchyItem) && this.hierarchyItem.length > 0) {
        this.jsondata = JSON.parse(JSON.stringify(this.hierarchyItem));
      } else {
        this.jsondata = []; // Vide mais valide
      }

      this.hasChanged = false;
      this.parametersChanged = false;
    },
    markChanged() {
      // let content = hierarchy;
      // console.log("🚀 ~ markChanged ~ content:", content);
      // this.parametersChanged = true;

      // this.jsondata[0].hierarchy = hierarchy;
      // //   this.jsondata = jsonmodel ;
      this.hasChanged = true;
      console.log("🔁 jsondata mis à jour :", this.jsondata);
    },
    loadConfiguration() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const allowedExtensions = /(\.xls|\.xlsx)$/i;
      if (!allowedExtensions.exec(file.name)) {
        alert("Veuillez sélectionner un fichier Excel (.xls ou .xlsx).");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 1) Convert the sheet to an array-of-arrays
        const jsonSheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 2) Cast all elements to string
        for (let r = 0; r < jsonSheet.length; r++) {
          for (let c = 0; c < jsonSheet[r].length; c++) {
            const val = jsonSheet[r][c];
            // If null or undefined, make it an empty string
            // otherwise cast to string
            jsonSheet[r][c] = val == null ? "" : String(val);
          }
        }

        this.loadedfile = jsonSheet;
        console.log(
          "Fichier chargé (tout converti en string):",
          this.loadedfile
        );
        //todo think about this
        // 3) Now call your import method
        //    (If you want to do it right after the file is read)
        this.importExcelToHierarchy(file, this.levels).then(() => {
          // Après avoir importé, forcer la mise à jour du composant
          this.$forceUpdate();
        });
        this.hasChanged = true;
      };

      reader.readAsArrayBuffer(file);
    },
    //************************************************************************************************************ */
    async importExcelToHierarchy(file, level) {
  try {

  
    const levels = [...level];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });

    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];

    const jsonSheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    if (!jsonSheet.length) {
   //   console.warn("Aucune donnée trouvée dans la feuille.");
            Swal.fire({
  icon: "error",
  title: "",
  text: this.$t("pages.Client.ExcelImport.EmptyFiles"),
  customClass: {
    popup: "swal-custom-zindex",
  },
});
      return;
    }

    const headers = jsonSheet[0].map((h) => (h || "").trim().toLowerCase());

    // Vérification des doublons dans la colonne 'groupingCode'
    const groupingCodeIndex = headers.findIndex(h => h === 'groupingcode' || h === 'groupingCode' || h === 'GROUPINGCODE');
    
    if (groupingCodeIndex !== -1) {
      // Extraire toutes les valeurs de groupingCode des données (ignorer la ligne d'en-tête)
      const groupingCodes = jsonSheet.slice(1)
        .map(row => row[groupingCodeIndex])
        .filter(code => code !== undefined && code !== null && String(code).trim() !== '');
      
      // Vérifier les doublons
      const duplicates = {};
      const uniqueCodes = new Set();
      
      groupingCodes.forEach(code => {
        const codeStr = String(code).trim();
        if (uniqueCodes.has(codeStr)) {
          duplicates[codeStr] = (duplicates[codeStr] || 1) + 1;
        } else {
          uniqueCodes.add(codeStr);
        }
      });
      
      // S'il y a des doublons, afficher un message d'alerte
      const duplicateKeys = Object.keys(duplicates);
      if (duplicateKeys.length > 0) {
        const duplicateList = duplicateKeys.map(code => `'${code}' (${duplicates[code]} occurrences)`).join(', ');
        
        await Swal.fire({
          icon: 'warning',
          title: this.$t('pages.Client.ExcelImport.DuplicateGroupingCodeTitle') || 'Doublons détectés',
          html: (this.$t('pages.Client.ExcelImport.DuplicateGroupingCodeMessage') || 'Des doublons ont été détectés dans la colonne \'groupingCode\'. Veuillez corriger ces valeurs avant de continuer.') + 
                '<br><br><strong>' + duplicateList + '</strong>',
          customClass: {
            popup: 'swal-custom-zindex',
          },
        });
        
        return; // Arrêter l'importation si des doublons sont détectés
      }
      
      // Vérification des codes de regroupement manquants quand la colonne précédente est remplie
      if (groupingCodeIndex > 0) {
        const previousColumnIndex = groupingCodeIndex - 1;
        const missingGroupingCodes = [];
      
            console.log('langue',  this.$i18n.locale );
        console.log('Vérification des codes de regroupement manquants...');
        console.log('Index de la colonne groupingCode:', groupingCodeIndex);
        console.log('Index de la colonne précédente:', previousColumnIndex);
        console.log('Nom de la colonne précédente:', headers[previousColumnIndex]);
        
        // Parcourir toutes les lignes (sauf l'en-tête)
        jsonSheet.slice(1).forEach((row, index) => {
          // S'assurer que row est un tableau et non undefined
          if (!row) {
            console.log(`Ligne ${index + 1}: row est undefined ou null`);
            return;
          }
          
          const previousValue = row[previousColumnIndex];
          const groupingCodeValue = row[groupingCodeIndex];
          
          console.log(`Ligne ${index + 1}: Valeur précédente = '${previousValue}', Valeur groupingCode = '${groupingCodeValue}'`);
          
          // Vérifier si la colonne précédente est remplie et que groupingCode est vide
          if (previousValue !== undefined && previousValue !== null && String(previousValue).trim() !== '' &&
              (groupingCodeValue === undefined || groupingCodeValue === null || String(groupingCodeValue).trim() === '')) {
            console.log(`Ligne ${index + 1}: Code de regroupement manquant pour '${String(previousValue).trim()}'`);
            missingGroupingCodes.push(String(previousValue).trim());
          }
        });
        
        // S'il y a des codes de regroupement manquants, afficher un message d'alerte
        console.log('Nombre de codes de regroupement manquants:', missingGroupingCodes.length);
        console.log('Codes de regroupement manquants:', missingGroupingCodes);
        
        if (missingGroupingCodes.length > 0) {
          let title = this.$t('pages.Client.ExcelImport.MissingGroupingCodeTitle') || 'Code de regroupement manquant';
          let message;
          
          if (missingGroupingCodes.length === 1) {
            // Message pour une seule organisation
            const name = missingGroupingCodes[0];
            console.log('Affichage du message pour une seule organisation:', name);
            // Créer le message directement sans utiliser $t avec des variables
            if (this.$i18n.locale === 'fr-FR') {
              message = `L'organisation "${name}" doit avoir un code de regroupement.`;
            } else {
              message = `The organization "${name}" must have a grouping code.`;
            }
          } else {
            // Message pour plusieurs organisations
            console.log('Affichage du message pour plusieurs organisations');
            // Limiter le nombre d'organisations affichées si nécessaire
            let displayedOrgs = [...missingGroupingCodes];
            if (displayedOrgs.length > 10) {
              displayedOrgs = displayedOrgs.slice(0, 10);
              displayedOrgs.push('...');
            }
            
            const namesFormatted = displayedOrgs.join('"</strong>, <strong>"');
            // Créer le message directement sans utiliser $t avec des variables
            if (this.$i18n.locale === 'fr-FR') {
              message = `Les organisations <strong>"${namesFormatted}"</strong> doivent avoir un code de regroupement.`;
            } else {
              message = `The organizations <strong>"${namesFormatted}"</strong> must have a grouping code.`;
            }
          }
          
          await Swal.fire({
            icon: 'warning',
            title: title,
            html: message,
            customClass: {
              popup: 'swal-custom-zindex',
            },
          });
          
          return; // Arrêter l'importation si des codes de regroupement sont manquants
        }
      }
    }else{
      //todo swal
            Swal.fire({
  icon: "error",
  title: this.$t("pages.Client.ExcelImport.HeaderMismatchTitle"),
  text: this.$t("pages.Client.ExcelImport.MissingGroupingCode"),
  customClass: {
    popup: "swal-custom-zindex",
  },
});
return ;
    }

    // Ajouter groupingCode à levels si présent dans l'en-tête mais pas déjà dans levels
    if (headers.includes("groupingcode") && !levels.includes("groupingCode")) {
      levels.push("groupingCode");
    }

    var effectiveLevels = [...levels];
var effectiveLevelsNumber = effectiveLevels.length;

if (effectiveLevels.map(level => level.toLowerCase()).includes("groupingcode")) {
  effectiveLevels = effectiveLevels.filter(level => level.toLowerCase() !== "groupingcode");
  effectiveLevelsNumber -= 1;
}

console.log("effectiveLevels ",effectiveLevels);
console.log("effectiveLevelsNumber ",effectiveLevelsNumber);
  

        // 4.1) Vérifier si les colonnes correspondent à `levels`, en ignorant UID et groupingCode
        const cleanedHeaders = headers.filter(
          (h) => h.toLowerCase() !== "uid" && h.toLowerCase() !== "groupingcode"
        );
        console.log(
          "🚀 ~ importExcelToHierarchy ~ cleanedHeaders:",
          cleanedHeaders
        );

     const expectedHeaders = effectiveLevels
  .filter((l) => l.toLowerCase() !== "groupingcode")
  .map((l) => l.trim().toLowerCase());
        console.log(
          "🚀 ~ importExcelToHierarchy ~ expectedHeaders:",
          expectedHeaders
        );
        const sameLength = cleanedHeaders.length === expectedHeaders.length;
        const allMatch = expectedHeaders.every((level) =>
          cleanedHeaders.includes(level)
        );
        console.log("🚀 ~ importExcelToHierarchy ~ allMatch:", allMatch);

        if (!sameLength || !allMatch) {
      Swal.fire({
  icon: "error",
  title: this.$t("pages.Client.ExcelImport.HeaderMismatchTitle"),
  text: this.$t("pages.Client.ExcelImport.HeaderMismatchMessage", {
    found: cleanedHeaders.join(", "),
    expected: expectedHeaders.join(", ")
  }),
  customClass: {
    popup: "swal-custom-zindex",
  },
});


          console.warn(
            this.$t("pages.Client.ExcelImport.CleanedHeaders"),
            cleanedHeaders
          );
          console.warn(this.$t("pages.Client.ExcelImport.ExpectedColumns"), expectedHeaders);
          return;
        }

    const levelIndexes = levels.map((level) =>
      headers.indexOf(level.trim().toLowerCase())
    );

    const projectName = this.client;
    const result = {
      project: projectName,
levelsNumber: effectiveLevelsNumber,
levels: effectiveLevels,
      hierarchy: {
        scope: `ALL.${projectName}`,
        name: projectName,
        parameters: this.buildDefaultParameters(),
        children: [],
      },
    };

    let currentPath = Array(levels.length).fill("");

    const dataRows = jsonSheet.slice(1);
    dataRows.forEach((rowArr) => {
      levels.forEach((level, i) => {
        const cellVal = rowArr[levelIndexes[i]];
        if (cellVal && String(cellVal).trim() !== "") {
          currentPath[i] = String(cellVal).trim();
          for (let j = i + 1; j < levels.length; j++) {
            currentPath[j] = "";
          }
          this.insertPathIntoTreeMerge(
            result.hierarchy,
            currentPath.slice(0, i + 1)
          );
        }
      });
    });

    // Vérifier si la hiérarchie contient des noms vides
    const emptyNodes = this.findEmptyNodeNames(result.hierarchy);
    
    if (emptyNodes.length > 0) {
      console.log('Valeurs vides détectées dans la hiérarchie:', emptyNodes);
      
      // Récupérer le titre et le message depuis les traductions
      let title = '';
      let message = '';
      
      try {
        title = this.$t('pages.Client.ExcelImport.EmptyNodeNameTitle');
      } catch (e) {
        // Fallback si la traduction n'est pas disponible
        title = this.$i18n.locale === 'fr-FR' ? 'Valeurs vides détectées' : 'Empty Values Detected';
      }
      
      try {
        message = this.$t('pages.Client.ExcelImport.EmptyNodeNameMessage');
      } catch (e) {
        // Fallback si la traduction n'est pas disponible
        message = this.$i18n.locale === 'fr-FR' 
          ? 'Des valeurs vides ont été détectées dans la hiérarchie. Veuillez vous assurer que toutes les valeurs sont remplies correctement.' 
          : 'Empty values have been detected in the hierarchy. Please ensure all values are properly filled.';
      }
      
      // Afficher le message d'alerte
      await Swal.fire({
        icon: 'warning',
        title: title,
        text: message,
        customClass: {
          popup: 'swal-custom-zindex',
        },
      });
      
      return; // Arrêter l'importation si des noms vides sont détectés
    }
    
    this.jsondata = JSON.parse(JSON.stringify([result]));
    this.$forceUpdate();
    console.log("🚀 ~ importExcelToHierarchy ~ jsondata :", this.jsondata);
  } catch (err) {
    console.error("Erreur lors de l'import Excel vers la hiérarchie :", err);
  }
}
,
    // async importExcelToHierarchy(file, levels) {
    //   try {
    //     // 1) Lire le fichier en ArrayBuffer
    //     const data = await file.arrayBuffer();
    //     const workbook = XLSX.read(data, { type: "array" });

    //     // 2) Sélectionner la première feuille
    //     const firstSheetName = workbook.SheetNames[0];
    //     const worksheet = workbook.Sheets[firstSheetName];

    //     // 3) Convertir en array-of-arrays (header = 1)
    //     const jsonSheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    //     if (!jsonSheet.length) {
    //       console.warn("Aucune donnée trouvée dans la feuille.");
    //       return;
    //     }

    //     // 4) Récupérer l'en-tête et déterminer les indices des colonnes dynamiques
    //     // const headers = jsonSheet[0].map((h) => (h || "").trim().toLowerCase());
    //     // 4) Récupérer l'en-tête
    //     const headers = jsonSheet[0].map((h) => (h || "").trim().toLowerCase());

    //     // 4.1) Vérifier si les colonnes correspondent à `levels`, en ignorant UID et groupingCode
    //     const cleanedHeaders = headers.filter(
    //       (h) => h.toLowerCase() !== "uid" && h.toLowerCase() !== "groupingcode"
    //     );
    //     console.log(
    //       "🚀 ~ importExcelToHierarchy ~ cleanedHeaders:",
    //       cleanedHeaders
    //     );

    //     const expectedHeaders = levels.map((l) => l.trim().toLowerCase());
    //     console.log(
    //       "🚀 ~ importExcelToHierarchy ~ expectedHeaders:",
    //       expectedHeaders
    //     );
    //     const sameLength = cleanedHeaders.length === expectedHeaders.length;
    //     const allMatch = expectedHeaders.every((level) =>
    //       cleanedHeaders.includes(level)
    //     );
    //     console.log("🚀 ~ importExcelToHierarchy ~ allMatch:", allMatch);

    //     if (!sameLength || !allMatch) {
    //       Swal.fire({
    //         icon: "error",
    //         title: "Oops...",
    //         text:
    //           "❌ Les colonnes du fichier Excel ne correspondent pas aux niveaux attendus.\n\n" +
    //           "Colonnes trouvées : [" +
    //           cleanedHeaders.join(", ") +
    //           "]\n" +
    //           "Colonnes attendues : [" +
    //           expectedHeaders.join(", ") +
    //           "]",
    //         customClass: {
    //           popup: "swal-custom-zindex",
    //         },
    //       });

    //       console.warn(
    //         "Colonnes Excel (hors UID/groupingCode):",
    //         cleanedHeaders
    //       );
    //       console.warn("Colonnes attendues (levels):", expectedHeaders);
    //       return;
    //     }

    //     const levelIndexes = levels.map((level) => {
    //       const idx = headers.indexOf(level.toLowerCase());
    //       if (idx < 0) {
    //         console.warn(
    //           `La colonne '${level}' n'a pas été trouvée dans l'en-tête.`
    //         );
    //       }
    //       return idx;
    //     });
    //     if (levelIndexes.some((idx) => idx < 0)) {
    //       console.warn(
    //         "Certaines colonnes définies dans levels sont manquantes dans l'en-tête."
    //       );
    //       return;
    //     }
    //   const groupingCodeIndex = headers.indexOf("groupingcode");

    //     // 5) Préparer l'objet final
    //     const projectName = this.client;
    //     const result = {
    //       project: projectName,
    //       // status: "Migrating",
    //       levelsNumber: levels.length,
    //       levels,
    //       // timezone: "Europe/Paris",
    //       // culture: "fr-FR",
    //       // gdpr: true,
    //       hierarchy: {
    //         scope: `ALL.${projectName}`,
    //         name: projectName,
    //         parameters: this.buildDefaultParameters(),
    //         children: [],
    //       },
    //     };

    //     // 6) Initialiser currentPath (tableau de longueur levels)
    //     let currentPath = Array(levels.length).fill("");

    //     // 7) Parcourir chaque ligne de données (après l'en-tête)
    //     const dataRows = jsonSheet.slice(1);
    //     dataRows.forEach((rowArr) => {

    //       // Pour chaque colonne correspondant à un niveau,
    //       // dès qu'une valeur non vide est détectée,
    //       // on met à jour le chemin et on insère le chemin jusqu'à ce niveau.
         
    //       levels.forEach((level, i) => {
    //         const cellVal = rowArr[levelIndexes[i]];
    //         if (cellVal && String(cellVal).trim() !== "") {
    //           currentPath[i] = String(cellVal).trim();
    //            console.log("INSERT currentPath[i]",i,currentPath[i]);
    //           // Réinitialiser les niveaux inférieurs
    //           for (let j = i + 1; j < levels.length; j++) {
    //             currentPath[j] = "";
    //           }
    //           // Insérer le chemin jusqu'au niveau i (i.e. currentPath[0..i])
    //           this.insertPathIntoTreeMerge(
    //             result.hierarchy,
    //             currentPath.slice(0, i + 1)
    //           );
    //         }
    //       });

    //       // Ensuite, si une valeur dans la colonne GroupingCode existe pour compléter le dernier niveau,
    //       // on l'utilise uniquement si le dernier niveau est toujours vide et que cette valeur
    //       // est différente du niveau précédent (pour éviter la duplication).
    //       if (
    //         groupingCodeIndex >= 0 &&
    //         rowArr[groupingCodeIndex] &&
    //         String(rowArr[groupingCodeIndex]).trim() !== "" &&
    //         currentPath[levels.length - 1] === ""
    //       ) {
    //         const groupingCodeVal = String(rowArr[groupingCodeIndex]).trim();
    //         // Si le niveau précédent n'est pas égal au grouping code, on complète le chemin complet
    //         if (
    //           levels.length < 2 ||
    //           groupingCodeVal !== currentPath[levels.length - 2]
    //         ) {
    //           currentPath[levels.length - 1] = groupingCodeVal;
    //           this.insertPathIntoTreeMerge(
    //             result.hierarchy,
    //             currentPath.slice()
    //           );
    //         }
    //       }
    //     });

    //     console.log("Hiérarchie importée (approche incrémentale) :", result);
    //     // this.jsondata = [result];
    //     this.jsondata = JSON.parse(JSON.stringify([result]));
    //     this.$forceUpdate();
    //     console.log(
    //       "🚀 ~ importExcelToHierarchy ~   this.jsondata :",
    //       this.jsondata
    //     );
    //   } catch (err) {
    //     console.error(
    //       "Erreur lors de l'import Excel vers la hiérarchie :",
    //       err
    //     );
    //   }
    // },
    /**
     * Always create new child nodes for each segment in `path`,
     * ensuring the last segment is included.
     * NO deduplication => might produce duplicates if rows share the same path.
     */
    /**
     * Builds a default "parameters" object with unknown fields set to null
     * (similar to your examples).
     */
    buildDefaultParameters() {
      return {
        performanceRadioFrameThreshold_1: null,
        performanceRadioFrameThreshold_5: null,
        performanceRadioFrameThreshold_7: null,
        performanceRadioFrameThreshold_10: null,
        performanceRadioFrameThreshold_30: null,
        // or any unknown fields => null
      };
    },

    /**
     * Recursively inserts `path` (array of strings) into the `rootNode.children`.
     * E.g. path=["SAINT_DIE_DES_VOSGES","88100","88413"] =>
     * scope = "ALL.MYPROJECT.SAINT_DIE_DES_VOSGES" => next => "ALL.MYPROJECT.SAINT_DIE_DES_VOSGES.88100" etc.
     */
    // This original approach reuses existing nodes if found
    // (so you only get unique paths)

    insertPathIntoTree(rootNode, path, projectName) {
      if (!path.length) return;

      const firstName = path[0];
      if (!firstName) return;

      const newScope = rootNode.scope + "." + firstName.replace(/\s+/g, "_");

      // If a child with that scope already exists, reuse it
      let childNode = rootNode.children.find(
        (child) => child.scope === newScope
      );
      if (!childNode) {
        // Otherwise create it
        childNode = {
          scope: newScope,
          name: firstName,
          parameters: this.buildDefaultParameters(),
          children: [],
        };
        rootNode.children.push(childNode);
      }

      // Recurse
      const restPath = path.slice(1);
      if (restPath.length) {
        this.insertPathIntoTree(childNode, restPath, projectName);
      }
    },
    insertPathIntoTreeMerge(rootNode, path) {
      let currentNode = rootNode;
      let currentScope = rootNode.scope;

      for (const segName of path) {
        // e.g. "SAINT_DIE_DES_VOSGES" => scope => "ALL.MYPROJECT.SAINT_DIE_DES_VOSGES"
        const segClean = segName.replace(/\s+/g, "_");
        const childScope = currentScope + "." + segClean;

        let child = currentNode.children.find((c) => c.scope === childScope);
        if (!child) {
          child = {
            scope: childScope,
            name: segName,
            parameters: this.buildDefaultParameters(),
            children: [],
          };
          currentNode.children.push(child);
        }

        currentNode = child;
        currentScope = childScope;
      }
    },
    
    /**
     * Parcourt récursivement l'arbre hiérarchique pour trouver les nœuds avec des noms vides
     * @param {Object} node - Le nœud à vérifier
     * @param {string} path - Le chemin actuel dans l'arbre (utilisé pour le débogage)
     * @returns {Array} - Un tableau contenant les chemins des nœuds avec des noms vides
     */
    findEmptyNodeNames(node, path = "") {
      if (!node) return [];
      
      let emptyNodes = [];
      const currentPath = path ? `${path} > ${node.name || "[Vide]"}` : node.name || "[Racine]";
      
      // Vérifier si le nom du nœud actuel est vide
      if (node.name !== undefined && (node.name === "" || (typeof node.name === "string" && node.name.trim() === ""))) {
        emptyNodes.push(currentPath);
      }
      
      // Parcourir récursivement les enfants du nœud
      if (node.children && Array.isArray(node.children)) {
        for (const child of node.children) {
          const childEmptyNodes = this.findEmptyNodeNames(child, currentPath);
          emptyNodes = emptyNodes.concat(childEmptyNodes);
        }
      }
      
      return emptyNodes;
    },
    insertPathIntoTree_noDedup(rootNode, path, projectName) {
      // If path is empty, nothing to add
      if (!path.length) return;

      // The first name in the path
      const firstName = path[0];
      // If empty, optionally skip
      if (!firstName) {
        return;
      }

      // create a new child node every time
      const cleanFirst = firstName.replace(/\s+/g, "_");
      const newScope = rootNode.scope + "." + cleanFirst;
      const childNode = {
        scope: newScope,
        name: firstName,
        parameters: this.buildDefaultParameters(),
        children: [],
      };
      rootNode.children.push(childNode);

      // Recurse on the remainder of the path
      const rest = path.slice(1);
      if (rest.length) {
        this.insertPathIntoTree_noDedup(childNode, rest, projectName);
      }
    },
    insertPathIntoTreeForceAll(rootNode, path) {
      // currentNode starts at root
      let currentNode = rootNode;
      // We'll build up a scope string as we go
      let currentScope = rootNode.scope;

      for (let i = 0; i < path.length; i++) {
        const segmentName = path[i];
        // If the segment is empty, you can skip or keep. We'll keep it:
        const safeName = segmentName || "EMPTY";

        // Append to scope
        const childScope = currentScope + "." + safeName.replace(/\s+/g, "_");

        // Make a brand-new child node for this segment
        const childNode = {
          scope: childScope,
          name: safeName,
          parameters: this.buildDefaultParameters(),
          children: [],
        };

        // Add to currentNode's children
        currentNode.children.push(childNode);

        // Advance "currentNode" to this newly created child
        currentNode = childNode;
        // Update currentScope
        currentScope = childScope;
      }
    },
  },
  watch: {
    currentScope(newVal) {
      if (newVal) {
        this.clientService = new ClientService(this.$jwt.token, newVal);
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.clientService = new ClientService(newVal, this.currentScope);
      }
    },
    show: function (newValue) {
      this.modalShow = newValue;

      if (newValue) {
        // Le popup vient de s'ouvrir
        console.log("📦 Props disponibles à l'ouverture du popup :");
        console.log("➡️ title:", this.title);
        console.log("➡️ client:", this.client);
        console.log("➡️ nbZones:", this.nbZones);
        console.log("➡️ levels:", this.levels);
        console.log("➡️ hierarchyItem:", this.hierarchyItem);
        console.log("➡️ fromPage:", this.fromPage);
        
        // Déterminer si les données proviennent de la base de données
        this.isDataFromDatabase = Array.isArray(this.hierarchyItem) && this.hierarchyItem.length > 0;
        
        // Assigner les données
        this.jsondata = this.hierarchyItem;
        
        // Sauvegarder une copie des données initiales pour l'annulation
        this.originalJsonData = this.isDataFromDatabase 
          ? JSON.parse(JSON.stringify(this.hierarchyItem)) 
          : [];
        
        console.log(
          "➡️ ~ jsondata after assigned from hierarchyItem:",
          this.jsondata
        );
        console.log(
          "➡️ ~ Données provenant de la base de données:",
          this.isDataFromDatabase
        );
      }
    },
    nbZones: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.formData = {};
      }
    },
    formData: {
      handler: function (newValue) {
        if (Object.keys(this.formData).length != this.nbZones) {
          this.error = true;
        } else {
          var error = false;
          for (const index in newValue) {
            if (newValue[index] == "") {
              error = true;
            }
          }

          if (error === true) {
            this.error = true;
            this.noData = true;
          } else {
            this.error = false;
            this.noData = false;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
});
</script>

<style scoped>
.disabledClass {
  cursor: inherit !important;
  color: #ccc !important;
}

.sef-modal-mask {
  position: fixed;
  /*z-index: 9998; */
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: 0.1 0.3s ease;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN";
  width: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card.full {
  width: 80%;
}

.card.notif .card-title {
  margin-right: 15px !important;
  color: #030f40;
}

.card.notif .modal-footer {
  justify-content: center;
}

.card.confirmation {
  width: 30%;
}

.modal-footer .btn-primary {
  background-color: #eee !important;
  padding: 5px 30px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #e2e6ec !important;
}

.card .card-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-radius: 6px 6px 0px 0px;
  font-size: 12pt;
  font-weight: bold;
  border-bottom: 2px solid #1973d2;
  box-sizing: unset !important;
}
.card .card-header p {
  margin-top: revert !important;
  margin-bottom: revert !important;
}

.card-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0 !important;
}
.card .btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.card .card-header .btn-group,
.btn-group-vertical {
  position: relative;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}
.card .card-header a {
  text-decoration: none;
}
.card .card-header a.btn.btn-focus i {
  /* margin-left: 10px;
        margin-right: 10px; */
  color: #1973d2;
  font-size: 12pt;
}
.card .card-header a.btn.btn-focus i:hover {
  opacity: 0.5;
}

.card-body {
  padding: unset !important;
}
.card .card-body-container {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
  background: #f4f6fb;
  max-height: 680px;
  padding-bottom: 10px;
}

.card.full .card-body-container {
  height: 70vh;
}

.card .notif .card-body-container {
  height: auto;
}

.card.confirmation .card-body-container {
  height: 100px;
}

.card .modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: space-between !important;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn-primary:hover {
  color: #030f40;
  background-color: #dddddd;
  border-color: #030f40;
}

.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-information {
  font-weight: normal;
}

.zone-container {
  display: flex;
  margin: 10px 0px;
}

.zone-container input {
  margin-left: 10px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  border-radius: 4px !important;
  border: 1.5px solid #030f40 !important;
}
</style>
<style scoped>
/* Adapted from .card and .card.notif to .modal-content */

/* Modal overlay remains similar */
.modal-overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

/* New modal-content styled based on card.notif */
.modal-content {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN", sans-serif;
  width: 310px; /* same as card width */
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

/* Adapted header from .card .card-header */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-bottom: 2px solid #1973d2;
  font-size: 12pt;
  font-weight: bold;
}

/* Optional: style for header title if needed */
.modal-title {
  margin: 0;
}

/* Adapted body from .card-body-container */
.modal-body {
  padding: 10px;
  /* font-family: Menlo, Consolas, monospace; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f4f6fb;
  /* overflow-y: auto; */
  max-height: 680px;
}

/* Adapted footer style (if needed) */
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}

/* Button styling (if you want to mimic your previous btn-primary) */
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}
.btn-primary:hover {
  background-color: #dddddd;
  border-color: #030f40;
}

.Information {
  padding: 20px;
  background-color: #2196f3;
  color: white;
}

.warn,
.warn::before,
.warn::after {
  position: relative;
  padding: 0;
  margin: 0;
}

.warn {
  font-size: 36px;
  color: transparent;
}

.warn.warning {
  display: inline-block;

  top: 0.225em;

  width: 1.15em;
  height: 1.15em;

  overflow: hidden;
  border: none;
  background-color: transparent;
  border-radius: 0.625em;
}

.warn.warning::before {
  content: "";
  display: block;
  top: -0.08em;
  left: 0em;
  position: absolute;
  border: transparent 0.6em solid;
  border-bottom-color: #fd3;
  border-bottom-width: 1em;
  border-top-width: 0;
  box-shadow: #999 0 1px 1px;
}

.warn.warning::after {
  display: block;
  position: absolute;
  top: 0.3em;
  left: 0;
  width: 100%;
  padding: 0 1px;
  text-align: center;
  font-family: "Garamond";
  content: "!";
  font-size: 0.65em;
  font-weight: bold;
  color: #333;
}
.swal-custom-zindex {
  z-index: 10000 !important;
}

.alert-container {
    position: relative;
    padding: 1rem 1.5rem 1rem 3rem;
    border: 1px solid #b3d9ff;
    border-left: 4px solid #2196f3;
    background-color: #e6f2ff;
    color: #0b3954;
    /* border-radius: 0.5rem; */
    margin: 1rem 0;
   /* font-family: sans-serif; */
    transition: all 0.3s ease;
    margin-right: 12px;
    margin-left: 19px;
}

.alert-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #2196f3;
}

.alert-close-label {
  position: absolute;
  right: 1rem;
  top: 1rem;
  font-size: 1.2rem;
  cursor: pointer;
  color: #0b3954;
}

input[type="checkbox"].alert-toggle {
  display: none;
}

input[type="checkbox"].alert-toggle:checked + .alert-container {
  display: none;
}
#cardnotif {
  min-width: 1646px;
}


/* From Uiverse.io by vinodjangid07 */ 
.Btn {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: rgb(27, 27, 27);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition-duration: .3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.11);
}

.svgIcon {
  fill: rgb(214, 178, 255);
}

.icon2 {
  width: 18px;
  height: 5px;
  border-bottom: 2px solid rgb(182, 143, 255);
  border-left: 2px solid rgb(182, 143, 255);
  border-right: 2px solid rgb(182, 143, 255);
}

.tooltip {
  position: absolute;
  right: -105px;
  opacity: 0;
  background-color: rgb(12, 12, 12);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: .2s;
  pointer-events: none;
  letter-spacing: 0.5px;
}

.tooltip::before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: rgb(12, 12, 12);
  background-size: 1000%;
  background-position: center;
  transform: rotate(45deg);
  left: -5%;
  transition-duration: .3s;
}

.Btn:hover .tooltip {
  opacity: 1;
  transition-duration: .3s;
}

.Btn:hover {
  background-color: rgb(150, 94, 255);
  transition-duration: .3s;
}

.Btn:hover .icon2 {
  border-bottom: 2px solid rgb(235, 235, 235);
  border-left: 2px solid rgb(235, 235, 235);
  border-right: 2px solid rgb(235, 235, 235);
}

.Btn:hover .svgIcon {
  fill: rgb(255, 255, 255);
  animation: slide-in-top 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

</style>

